export default __webpack_public_path__ + "static/media/menu.d2f27af6.svg";